export const saveToLocalStorage = (key, value) => {
    localStorage.setItem(key, JSON.stringify(value));
};

export const getFromLocalStorage = (key) => {
    try {
      const item = localStorage.getItem(key);
      if (item && item.startsWith('{') && item.endsWith('}')) {
        return JSON.parse(item);
      }
      return item;
    } catch (error) {
      console.error(`Error reading from localStorage (key ${key}):`, error);
      return null;
    }
  };

export const deleteFromLocalStorage = (key) => {
    localStorage.removeItem(key);
};

export const updateLocalStorage = (key, value) => {
    const existingItem = getFromLocalStorage(key);
    const updatedItem = { ...existingItem, ...value };
    saveToLocalStorage(key, updatedItem);
};
